import React from "react";
import { highlights } from "../mock";

const Highlights = () => (
  <section id="highlights-section" className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundImage: `url(${highlights.bg})`, backgroundSize: "cover" }}>
    <div className="absolute inset-0 bg-[#f4ede2]/90" />
    <img src={highlights.flower1} alt="" className="ornament right-0 top-10 w-40 opacity-70" />
    <img src={highlights.multiFlowers} alt="" className="ornament left-0 bottom-0 w-40 opacity-70" />
    <div className="relative max-w-[1220px] mx-auto px-5 lg:px-8">
      <div className="section-head">
        <p className="eyebrow">Highlights</p>
        <div className="divider-leaf my-3" />
        <h2 className="h-title">Values Of Smart Living In Our Residence</h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div className="relative rounded-[22px] overflow-hidden shadow-[0_24px_50px_rgba(31,58,42,0.15)]">
          <img src={highlights.image} alt="Highlights" className="w-full h-[480px] object-cover" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {highlights.items.map((it, i) => (
            <div key={i} className="flex items-center gap-4 bg-white/80 border border-[#c26a4a]/25 rounded-xl p-4 card-lift">
              <div className="w-14 h-14 shrink-0 rounded-full bg-[#2a3d5c] flex items-center justify-center">
                <img src={it.icon} alt="" className="w-7 h-7 object-contain" style={{ filter: "brightness(0) invert(1) sepia(1) saturate(2) hue-rotate(15deg)" }} />
              </div>
              <p className="font-serif-e text-[17px] text-[#2a3d5c] font-medium">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Highlights;
